import React from 'react';
import intl from 'react-intl-universal';
import * as R from 'ramda';
import { DetailItem } from '@/components/Details';
import { isEqual } from 'lodash';

import withCurrentOrganization from '@/containers/Organization/withCurrentOrganization';

/**
 * Detail exchange rate item.
 * @param {*} param0
 * @param {*} param1
 * @returns
 */
/**
 * Map of exchange_rate_source codes (from sales_invoices / bills) to the
 * short label shown next to the rate. Saved at AI-import time by
 * InvoiceSaveService.resolveExchangeRate — auditors need to know which
 * branch of the cascade produced the booked rate.
 */
const SOURCE_LABEL_KEYS = {
  manual: 'exchange_rate.source.manual',
  ocr: 'exchange_rate.source.ocr',
  bam: 'exchange_rate.source.bam',
  fallback: 'exchange_rate.source.fallback',
};

interface DetailExchangeRateProps {
  exchangeRate?: number | string;
  exchangeRateSource?: string;
  exchangeRateDate?: string;
  toCurrency?: string;
  // #withCurrentOrganization
  organization: { base_currency?: string };
}

function DetailExchangeRate({
  exchangeRate,
  exchangeRateSource,
  exchangeRateDate,
  toCurrency,
  // #withCurrentOrganization
  organization: { base_currency },
}: DetailExchangeRateProps) {
  if (isEqual(base_currency, toCurrency)) {
    return null;
  }

  const sourceKey =
    exchangeRateSource != null
      ? SOURCE_LABEL_KEYS[exchangeRateSource as keyof typeof SOURCE_LABEL_KEYS]
      : undefined;
  const suffix = sourceKey
    ? ` (${intl.get(sourceKey)}${exchangeRateDate ? ` · ${exchangeRateDate}` : ''})`
    : '';

  return (
    <DetailItem label={intl.get('exchange_rate')}>
      {/* `exchangeRate` follows the stored `rateToMad` convention: how many
          units of the base currency (MAD) equal 1 unit of `toCurrency`. */}
      1 {toCurrency} = {exchangeRate} {base_currency}
      {suffix}
    </DetailItem>
  );
}

export const ExchangeRateDetailItem = R.compose(withCurrentOrganization())(
  DetailExchangeRate,
);
